import React from 'react'
import {Input, TitleText} from '../../../common'
import {EditAllergyKey} from '../utils/keys'
import AllergyRadio from './AllergyRadio'
import {i18n} from '../../../../i18n'

type AllergyFieldKey = (typeof EditAllergyKey)[keyof typeof EditAllergyKey]

interface EditAllergySectionProps {
    extractAllergyProps: (fieldKey: AllergyFieldKey) => any
}

const EditAllergiesSection: React.FC<EditAllergySectionProps> = ({extractAllergyProps}) => {
    
    return (
        <div>
            <TitleText text={i18n.t('userDataTab.allergyinfo.allergySectionTitle')} />
            <AllergyRadio
                label={i18n.t('userDataTab.allergyinfo.allergySectionTitle')}
                {...extractAllergyProps(EditAllergyKey.allergyCondition)}></AllergyRadio>
            <Input 
                label={i18n.t('userDataTab.allergyinfo.allergies')} 
                {...extractAllergyProps(EditAllergyKey.allergies)} 
                disabled={extractAllergyProps(EditAllergyKey.allergyCondition).value !== 'hasAllergies'}/>
        </div>
    )
}

export default EditAllergiesSection
